import { Utils } from "revlock-webutils";

/**
 * Context class for Revenue Arrangement processing.
 * @class RevenueArrangementContext
 * @constructor
 * @param {Object}
 * clientReferenceData - Client reference data for processing.
 * @param {Array} errors - Array to collect errors during processing.
 * @param {boolean} isApiCall - Flag indicating if the call is from an API.
 * @example
 * const context = new RevenueArrangementContext(clientReferenceData, errors, isApiCall);
 */
export default class RevenueArrangementContext {
    constructor(clientReferenceData, errors, isApiCall) {
        let {
            options,
            journalAccounts,
            clientAttributes,
            organization,
            orgConfig,
            configProvider,
            customCode
        } = clientReferenceData;

        // By default create the revenue plans for all sales items.
        this.options = Object.assign(
            {
                createRevenuePlan: true
            },
            options
        );

        this.errors = errors;
        this.isApiCall = isApiCall;
        this.clientReferenceData = clientReferenceData;

        this.journalAccounts = journalAccounts;
        this.clientAttributes = clientAttributes;
        this.organization = organization;
        this.orgConfig = orgConfig;
        this.configProvider = configProvider;
        this.customCode = customCode;
        this.orgConfigByKey = Utils.getOrgConfigByKey(orgConfig, false);
        this.calendarConfig = configProvider.calendarConfig();
        this.unearnedByValue = configProvider.unearnedByValueConfig();
        this.recognizeByTransactionDate =
            configProvider.recognizeByTransactionDateConfig();
        this.psdByProductCode = configProvider.psdByProductCodeConfig();
        this.endDateInclusive = configProvider.endDateInclusiveConfig();
        this.disableCnAllocation =
            configProvider.disableCreditNoteAllocationConfig();
        this.cnAllocationByBacklog = configProvider.cnAllocationByBacklog();
        this.roundPrecision = configProvider.revenueRoundPrecision();
        this.setSalePriceForBundleComponents =
            configProvider.setSalePriceForBundleComponents();
        this.cFields = configProvider.customFieldsValues();
        this.dereferenceRuleHasPriority =
            configProvider.dereferenceRuleHasPriority();
        this.disableProduct =
            configProvider.dereferenceRuleHasPrioryDisableProduct();
        this.useProductListPrice = configProvider.useProduceListPriceConfig();
        this.expenseReasonCode = configProvider.expenseReasonCode();
    }

    setRemovedRevenueArrangement(revenueArrangement) {
        this.removedRevenueArrangement = revenueArrangement;
    }
}
